export default "__VITE_ASSET__Cd3PSJ0P__"